// walk-wall-world.ts — MV3 (2026-10-03, R-008 rung `room-clearance`): the WALL world a walk is judged in — the scene's own shape (the
// served shape with its live door states, sent on the walk input as `shape`, index.ts floorTruthShape()), or the authored one with its
// opening overlays unknown (inventory-floor-move-truth.ts encounterShape — the same resolver the I1 floor move and the Force Move use),
// plus ft_encounter_canvas_is_exterior(). Registered with movement-truth.ts (an import there would close a cycle:
// inventory-floor-move-truth.ts imports movement-truth.ts).
import { encounterShape } from './inventory-floor-move-truth.js';
import { registerWalkWallWorld } from './movement-truth.js';

type Row = Record<string, unknown>;
const asRow = (value: unknown): Row | null => value !== null && typeof value === 'object' && !Array.isArray(value) ? value as Row : null;

registerWalkWallWorld((encounter, provided) => {
  const inventories = Array.isArray(encounter.encounter_inventories_arr) ? encounter.encounter_inventories_arr as Row[] : [];
  const resolved = encounterShape(encounter, inventories, provided);
  if (!resolved.shape) return null;
  const encounters = asRow(encounter.encounters) ?? {};
  const raw = encounters.encounter_inside ?? encounter.encounter_inside ?? 0;
  const inside = Number(Array.isArray(raw) ? raw[0] : raw);
  return { shape: resolved.shape, canvasExterior: inside !== 1, overlayUnknown: resolved.overlayUnknown };
});
